import Vue from 'vue'

const files = require.context('@/components/icon', true, /\.vue$/i)
files.keys().map((key) => {
  return Vue.component(
    `icon-${key.split('/').pop().split('.')[0]}`,
    files(key).default
  )
})
